import { render } from "./IdleWarningModal.vue?vue&type=template&id=c32bfb98"
import script from "./IdleWarningModal.vue?vue&type=script&lang=js"
export * from "./IdleWarningModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__